import { featureFlags } from "@/mixins/featureFlags.js";

export const permissions = {
  mixins: [featureFlags],
  inject: ["currentUser"],
  methods: {
    hasPermission(permission) {
      const userIsAdmin = this.currentUser.user.role === "admin";

      switch (permission) {
        case "maturity.any_change":
          return (
            userIsAdmin || this.hasFeatureFlag("allow_users_changing_rubric")
          );
        case "service_levels.manage":
        case "service_templates.any_change":
        case "git_integrations.delete":
        case "service_discovery.edit":
        case "entity.any_change":
        case "actions.manage":
          return userIsAdmin;
        default:
          throw new Error(`Unrecognized permission: ${permission}`);
      }
    },
  },
};
